var map = {
	"./featured-blogs.de-CH.json": 1290,
	"./featured-blogs.de-DE.json": 1291,
	"./featured-blogs.en-CA.json": 1292,
	"./featured-blogs.en-GB.json": 1293,
	"./featured-blogs.en-IN.json": 1294,
	"./featured-blogs.en-ME.json": 1295,
	"./featured-blogs.en-US.json": 1296,
	"./featured-blogs.es-EM.json": 1297,
	"./featured-blogs.es-ES.json": 1298,
	"./featured-blogs.fr-BE.json": 1299,
	"./featured-blogs.fr-CA.json": 1300,
	"./featured-blogs.fr-CH.json": 1301,
	"./featured-blogs.nl-BE.json": 1302,
	"./featured-blogs.nl-NL.json": 1303,
	"./featured-blogs.pl-PL.json": 1304,
	"./featured-blogs.pt-BR.json": 1305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1289;